import { Grid, Box, IconButton, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useObjectsPagination } from "./hooks/useObjectsPagination";
import { colors } from "../../../../../../../ui/colors";
import { useAppDispatch, useAppSelector } from "../../../../../../../../redux/hooks/redux";
import { selectObjects } from "../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";
import { quoteCreateActions } from "../../../../../../../../redux/features/quotes/quote-create-advanced";
import { ObjectsCard } from "./components/ObjectsCard";
import { ObjectsSearchBar } from "./components/ObjectsSearchBar";
import { useState } from "react";
import { ObjectsPlaceholderCard } from "./components/ObjectsPlaceholderCard";
import { useExtendedLoading } from "../../../../../../../shared/hooks/useExtendedLoading";

export const Objects = () => {
  const [search, setSearch] = useState("");

  const {
    isLoading,
    items,
    goNextPage,
    goPrevPage,
    page,
    totalPages,
  } = useObjectsPagination(8, search);

  const extendedLoading = useExtendedLoading(isLoading, 400);

  const { toggleObject } = quoteCreateActions;
  const selectedObjects = useAppSelector(selectObjects);
  const dispatch = useAppDispatch();

  const PLACEHOLDER_COUNT = 8;

  const noResults = !extendedLoading && items.length === 0;

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <ObjectsSearchBar value={search} onChange={setSearch} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          py: 1,
        }}
      >
        <IconButton
          onClick={goPrevPage}
          disabled={page === 1}
          sx={{ color: page === 1 ? colors.gray[300] : colors.orange.base }}
        >
          <ChevronLeft fontSize="large" />
        </IconButton>

        <Typography fontWeight={700} color={colors.gray[700]}>
          Page {page} / {totalPages}
        </Typography>

        <IconButton
          onClick={goNextPage}
          disabled={page === totalPages}
          sx={{ color: page === totalPages ? colors.gray[300] : colors.orange.base }}
        >
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>

      <Grid container spacing={2} mt={1}>
        {/* LOADING PLACEHOLDERS */}
        {extendedLoading &&
          Array.from({ length: PLACEHOLDER_COUNT }).map((_, i) => (
            <Grid item xs={6} sm={4} md={3} key={`loading-${i}`}>
              <ObjectsPlaceholderCard />
            </Grid>
          ))}

        {/* REAL ITEMS */}
        {!extendedLoading &&
          items.map((object) => (
            <Grid item xs={6} sm={4} md={3} key={object.uid}>
              <ObjectsCard
                object={object}
                selected={!!selectedObjects.find((x) => x.uid === object.uid)}
                onSelect={() => dispatch(toggleObject(object))}
              />
            </Grid>
          ))}

        {/* NO RESULTS PLACEHOLDER */}
        {noResults && (
          <Grid item xs={12}>
            <Box
              sx={{
                width: "100%",
                textAlign: "center",
                py: 6,
                color: colors.gray[500],
                fontSize: 16,
                fontWeight: 500,
              }}
            >
              No results found.
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
